import { render, staticRenderFns } from "./FormFooter.vue?vue&type=template&id=af025206&scoped=true"
import script from "./FormFooter.vue?vue&type=script&lang=js"
export * from "./FormFooter.vue?vue&type=script&lang=js"
import style0 from "./FormFooter.vue?vue&type=style&index=0&id=af025206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af025206",
  null
  
)

export default component.exports